import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FcmService } from './fcm.service';
import { NotificationListenerService } from './notification-listener.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent {
  constructor(
    readonly fcmService: FcmService, // injected to start push notifications
    readonly notificationListener: NotificationListenerService,
    private readonly titleService: Title
  ) {
    this.titleService.setTitle(environment.appTitle);
  }
}
